enum Timezone {
  // US Timezones
  AmericaAdak = 'America/Adak',
  AmericaAnchorage = 'America/Anchorage',
  AmericaBoise = 'America/Boise',
  AmericaChicago = 'America/Chicago',
  AmericaDenver = 'America/Denver',
  AmericaDetroit = 'America/Detroit',
  AmericaIndianaIndianapolis = 'America/Indiana/Indianapolis',
  AmericaIndianaMarengo = 'America/Indiana/Marengo',
  AmericaIndianaKnox = 'America/Indiana/Knox',
  AmericaIndianaPetersburg = 'America/Indiana/Petersburg',
  AmericaIndianaTell_City = 'America/Indiana/Tell_City',
  AmericaIndianaVevay = 'America/Indiana/Vevay',
  AmericaIndianaVincennes = 'America/Indiana/Vincennes',
  AmericaIndianaWinamac = 'America/Indiana/Winamac',
  AmericaKentuckyLouisville = 'America/Kentucky/Louisville',
  AmericaKentuckyMonticello = 'America/Kentucky/Monticello',
  AmericaJuneau = 'America/Juneau',
  AmericaLosAngeles = 'America/Los_Angeles',
  AmericaMenominee = 'America/Menominee',
  AmericaMetlakatla = 'America/Metlakatla',
  AmericaNewYork = 'America/New_York',
  AmericaNome = 'America/Nome',
  AmericaNorthDakotaBeulah = 'America/North_Dakota/Beulah',
  AmericaNorthDakotaCenter = 'America/North_Dakota/Center',
  AmericaNorthDakotaNewSalem = 'America/North_Dakota/New_Salem',
  AmericaPhoenix = 'America/Phoenix',
  AmericaPuertoRico = 'America/Puerto_Rico',
  AmericaSitka = 'America/Sitka',
  AmericaYakutat = 'America/Yakutat',
  PacificHonolulu = 'Pacific/Honolulu',

  // Canada Timezones
  AmericaEdmonton = 'America/Edmonton',
  AmericaHalifax = 'America/Halifax',
  AmericaRegina = 'America/Regina',
  AmericaToronto = 'America/Toronto',
  AmericaStJohns = 'America/St_Johns',
  AmericaVancouver = 'America/Vancouver',
  AmericaWhitehorse = 'America/Whitehorse',
  AmericaWinnipeg = 'America/Winnipeg',

  // European Timezones
  EuropeBerlin = 'Europe/Berlin',
  EuropeLondon = 'Europe/London',
}

export { Timezone };
